import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgSearch = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.032 16.618a9 9 0 10-1.414 1.414l3.675 3.675a1 1 0 001.414-1.414l-3.675-3.675zM11 18a7 7 0 110-14 7 7 0 010 14z", fill: color })));
};
export default factorySvgIcon(SvgSearch);
//# sourceMappingURL=SvgSearch.js.map